module.exports = __webpack_public_path__ + "img/gettedticket3.b3038916.png";